import { useEffect, useState } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useSearchParams } from 'react-router-dom';
import { Card, Center, Loader, Stack, Text, Title } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import ContainerLayout from '@/components/layout/ContainerLayout';
import { sendPaymentStatus } from '@/services/api/payment/payment.service';
import animationData from '../../assets/success.json';

const PaymentFeedback = () => {
  const [searchParams] = useSearchParams();
  const [playAnimation, setPlayAnimation] = useState(false);

  const payment = searchParams.get('payment');
  const status = searchParams.get('status');
  const merchantOrder = searchParams.get('payment');

  // {"payment":"1321625510","status":"approved","merchantOrder":"27313580259"}
  const mutation = useMutation({
    mutationFn: async () => {
      if (payment === null || status === null || merchantOrder === null) {
        throw new Error('Parâmetros inválidos ou ausentes.');
      }
      return await sendPaymentStatus({ payment, status, merchantOrder });
    },
    onSuccess: async () => {
      setPlayAnimation(true);
    },
    onError: (error: AxiosError) => {
      if (error.response) {
        const responseData = error.response.data as { message: string };

        showNotification({
          color: 'red',
          title: 'Erro ao cadastrar categoria',
          message: responseData.message,
        });
      }
    },
  });

  const { isPending, isSuccess, isError } = mutation;

  useEffect(() => {
    if (payment && status && merchantOrder && !isPending && !isSuccess && !isError) {
      mutation.mutate();
    }
  }, [payment, mutation]);

  return (
    <ContainerLayout>
      <Title order={3} fw={700} tt="uppercase">
        informações de recebimento
      </Title>
      <Card shadow="lg" padding={50} radius="lg" withBorder>
        {playAnimation && (
          <Stack align="center" gap="xl">
            <Player
              autoplay
              loop={false}
              keepLastFrame
              src={animationData}
              style={{ height: '200px', width: '200px' }}
            />

            <Text ta="center" fz={{ base: 20, xs: 30 }} fw={700}>
              Parabéns!
            </Text>
            <Text ta="center" fz={{ base: 20, xs: 30 }}>
              Compra aprovada 🎉
            </Text>
            <Text ta="center" fz={{ base: 20, xs: 30 }}>
              Agora você poderá receber os valores pagos pelos seus eventos. 🎉
            </Text>
          </Stack>
        )}

        {isPending && (
          <Center h="100vh">
            <Text>Enviando dados de recebimento...</Text>
            <Loader color="principal" type="bars" />
          </Center>
        )}
      </Card>
    </ContainerLayout>
  );
};

export default PaymentFeedback;
